export const environment = {
  production: false,
  apiUrl:'https://uas.dev.realtimedsm.com/api',
};
// development